import { Query } from './store';
import { RootModel } from './root.model';

export interface Params {
  [key: string]: string | number | string[] | number[];
}

export interface BackendConfig {
  endpoint: string;
  isGaf?: boolean;
  params: Params;
};

export interface Backend {
  fetch?: (key: string, query: Query) => BackendConfig;
  post?: (key: string) => {
    endpoint: string;
  };
};

export const backend: { [k in keyof RootModel]: Backend } = {
  threads: {
    fetch: (key) => ({
      endpoint: `messages/0.1/threads`,
      params: {
        unread_count: 'true',
        last_message: 'true',
        message_details: 'true',
        context_details: 'true',
        user_details: 'true',
      }
    })
  },
  threadUnreadCount: {},
  navigationUserInfo: {
    fetch: () => ({
      endpoint: `navigation/user-info.php`,
      isGaf: true,
      params: {}
    })
  },
  navigationNotificationPreferences: {
    fetch: () => ({
      endpoint: `navigation/get_notify_prefs.php`,
      isGaf: true,
      params: {}
    })
  },
  navigationProjectFeed: {
    fetch: () => ({
      endpoint: `navigation/project-feed/pre-populated.php`,
      isGaf: true,
      params: {}
    })
  },
  navigationProjectFeedFailingProjects: {
    fetch: () => ({
      endpoint: `navigation/project-feed/pre-populated-xp-projectcontest.php`,
      isGaf: true,
      params: {
        type: 'p'
      }
    })
  },
  navigationProjectFeedFailingContests: {
    fetch: () => ({
      endpoint: `navigation/project-feed/pre-populated-xp-projectcontest.php`,
      isGaf: true,
      params: {
        type: 'c'
      }
    })
  },
  navigationUserRecentProjectsAndContests: {
    fetch: () => ({
      endpoint: `navigation/recent-projects-and-contests.php`,
      isGaf: true,
      params: {}
    })
  },
  navigationUserBalances: {
    fetch: () => ({
      endpoint: `users/0.1/self`,
      params: {
        'balance_details': 1
      }
    })
  },
  messages: {
    fetch: (key) => ({
      endpoint: `messages/0.1/messages`,
      params: {
        'threads[]': key,
      }
    }),
    post: (key) => ({
      endpoint: `messages/0.1/threads/${key}/messages/`,
      params: {
        thread_id: key
      }
    })
  },
  giveGetEligibility: {
    fetch: (key) => ({
      endpoint: `users/0.1/referral_invitations/check`,
      params: {
        'bonus_id': '16'
      },
    }),
  },
  onlineOffline: {
  }
};



// WEBPACK FOOTER //
// ./src/app/@shared/datastore/backend.ts